const goods = {
  state: {
    uploadUrl: '',
    cityName: ''
  },
  mutations: {
    SAVE_UPLOADURL: (state, url) => {
      state.uploadUrl = url
    }
  },
  actions: {
    saveUploadUrl ({ commit }, url) {
      commit('SAVE_UPLOADURL', url)
    },
    storageCity ({ commit }, { cityName, region }) {
      return new Promise((resolve, reject) => {
        let cityData = JSON.parse(localStorage.cityNew)
        cityData[cityName] = region
        localStorage.cityNew = JSON.stringify(cityData)
      })
    }
  }
}

export default goods
